// extracted by mini-css-extract-plugin
module.exports = {"about":"style_about__7fqKB"};